export enum JoinTypeEnum {
    Inner = 1,
    Left,
    Righ,
    Outer
}
